import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject } from 'mobx-react';
import { FormattedMessage } from 'ui/i18n';
import { CUSTOMER_PHONE_NUMBER, COUNTRIES } from 'config/constants';

import './ErrorLoadingContent.scss';

@inject('AppState')
export default class ErrorLoadingContent extends Component {
	static propTypes = {
		AppState: PropTypes.object.isRequired,
	};

	render() {
		const countryName = this.props.AppState.user
			? this.props.AppState.user.country.long_name
			: COUNTRIES.US;

		const customerPhone = CUSTOMER_PHONE_NUMBER[countryName];

		return (
			<div className="ErrorLoadingContent">
				<p className="error">
					<FormattedMessage id="general.errorLoadingContent" />
				</p>
				<p>
					<FormattedMessage id="errorLoading.temporaryProblemText" />
				</p>
				<p>
					<FormattedMessage
						id="errorLoading.ifYouContinueMessage"
						values={{ customerPhone }}
					/>
				</p>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/ErrorLoadingContent/index.js